<template>
  <div
    class="product-card-disclaimer p-2 relative bg-EXPONDO-white border cursor-pointer flex gap-2"
    @click="handleDisclaimerClick"
  >
    <span :class="{ 'line-clamp-2': toggleDisclaimerText }">{{ $t('b-ware disclaimer') }}</span>
    <span class="iconify svg--info text-EXPONDO-primary inline-block flex-shrink-0" />
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductCardDisclaimer',
  setup() {

    const toggleDisclaimerText = ref(true);

    const handleDisclaimerClick = () => {

      toggleDisclaimerText.value = !toggleDisclaimerText.value;
    
    };

    return {
      toggleDisclaimerText,
      handleDisclaimerClick,
    };
  
  },
});

</script>
